import { render, staticRenderFns } from "./PDPPricing.vue?vue&type=template&id=dc7b81c8&scoped=true"
import script from "./PDPPricing.vue?vue&type=script&lang=js"
export * from "./PDPPricing.vue?vue&type=script&lang=js"
import style0 from "./PDPPricing.vue?vue&type=style&index=0&id=dc7b81c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7b81c8",
  null
  
)

export default component.exports